import { SDLUtil, RequestUtil } from '@/utils';

const setRemDivisionList = ({ commit }, data) => {
  commit('SET_REM_DIVISION_LIST', data);
};

export default {
  async GET_REM_DIVISION_LIST(store) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/rem/common/GetDivisions`);
    const divisionList = response.data.data;
    setRemDivisionList(store, divisionList);
    return response;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/rem/division/divisionActions.js